import {
  Header as HeaderComponent,
  SyncroStatus,
  Variant,
} from 'app/components/Common/Header'
import { Props as MenuItemProps } from 'app/components/Common/Header/MenuItem'
import { Props as FlashNewsProps } from 'app/components/FlashNews'
import React, { createContext, memo } from 'react'

import { getHeaderProps } from './getHeaderProps'

export interface Props {
  address?: string
  benefits?: any
  beachCTA?: string
  bookingID?: string
  email?: string
  flashNewsProps?: FlashNewsProps
  languageCode?: string
  languagesList?: string[]
  languagePrefix?: string | null
  menuItems: { [key: string]: MenuItemProps[] }[]
  pageID?: string
  phone?: string
  quotationPageURL?: string
  siteName?: string
  syncroStatus?: SyncroStatus
  variant?: Variant
}

export const HeaderContext = createContext({})

export const Header = memo(function Header({
  address,
  benefits,
  beachCTA,
  bookingID,
  email,
  flashNewsProps,
  languageCode,
  languagesList,
  languagePrefix,
  menuItems,
  pageID,
  phone,
  quotationPageURL,
  siteName,
  syncroStatus,
  variant = 'default',
}: Props) {
  const props = getHeaderProps(languagesList, menuItems, pageID)

  return props ? (
    <HeaderContext.Provider
      value={{
        address,
        benefits,
        beachCTA,
        bookingID,
        email,
        flashNewsProps,
        languageCode,
        languagePrefix,
        phone,
        quotationPageURL,
        siteName,
        syncroStatus,
        variant,
      }}
    >
      <HeaderComponent {...props} flashNewsProps={flashNewsProps} />
    </HeaderContext.Provider>
  ) : null
})
